import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "present_rule_name",
    name: "Gift Rule Name",
  },
  {
    key: "present_name",
    parent: "present",
    name: "Gift Name",
  },
  {
    key: "qty",
    name: "Quantity",
  },
  {
    key: "minimum_point",
    name: "Minimum Point",
  },
  {
    key: "status",
    name: "Status",
  },
];

const GiftRuleList = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchValue, setSearchValue] = useState("");

  // const handleSearch = (value) => {
  //   console.log("searching value: ", value);
  // };

    const handleSearch = (value) => {
    //console.log("searching value: ", value);
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({
      
    });
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/presentRule",
    defaultQuery: "status=ACTIVE",
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Gift Rule List"
      data={data}
      headers={headers}
      idKey="present_rule_id"
      endPoint="/presentRule"
      setCurrentPage={setCurrentPage}
      removeDetails={true}
      hasSearch
      hasCreate
      hasActions
      module="Loyalty"
      subModule="Gift Rule List"
      createPath={`/loyalty/gift-rule/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
};

export default GiftRuleList;
